import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AxiosController from "../../../authentication/AxiosController";
import { useTranslation } from "react-i18next";
import { Alert, Button, Modal } from "react-bootstrap";
import Loader from "../../../loader/Loader";
import SuppliersTableRow from "./SuppliersTableRow";
import { Helmet } from "react-helmet";

const get_warehouses = (slug, lang, token, handleWarehouses, handleLoader) => {
  AxiosController.get(`api/${slug}/${lang}/get-suppliers/`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      handleWarehouses(res.data);
      handleLoader(false);
    })
    .catch((e) => {
    });
};
const createWarehouse = (
  slug,
  lang,
  token,
  supplier_name,
  handleLoader,
  handleWarehouses,
  setShow,
  handleNewSupplierNameErr
) => {
  handleLoader(true);
  AxiosController.post(
    `api/${slug}/${lang}/new-supplier/`,
    { supplier_name },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      get_warehouses(slug, lang, token, handleWarehouses, handleLoader);
      setShow(false);
    })
    .catch((e) => {
      handleNewSupplierNameErr(
        e.response.data.errors ? e.response.data.errors.supplier_name[0] : ""
      );
      handleLoader(e.response.data.errors ? false : true);
    });
};

const Suppliers = () => {
  const { slug, lang } = useParams();

  const token = localStorage.getItem("token");
  const [_] = useTranslation("global");
  const [suppliers, handleSuppliers] = useState([]);
  const [loading, handleLoader] = useState(false);
  const [newSupplierName, handleNewSupplierName] = useState("");
  const [newSupplierNameErr, handleNewSupplierNameErr] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const box_head_dir = lang === "en" ? "ltr" : "rtl";

  useEffect(() => {
    get_warehouses(slug, lang, token, handleSuppliers, handleLoader);
  }, [slug, lang]);

  return (
    <div
      className="position-relative tables-container"
      style={{ minHeight: "100px", width: "100%" }}
    ><Helmet>
    <title>{_("panel.suppliers")}</title> 
 </Helmet>
      <Button
        variant="primary"
        onClick={handleShow}
        style={{ background: "#59C6C9", color: "white", border: "none" }}
      >
        {_("panel.add")}
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-0" dir={box_head_dir}>
          <Modal.Title className="flex-grow-1">
            {_("panel.addwarehouse")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body dir={box_head_dir}>
          {label_input(
            _("home.suppliername"),
            newSupplierName,
            handleNewSupplierName
          )}
          {newSupplierNameErr ? (
            <Alert variant="danger">{newSupplierNameErr}</Alert>
          ) : (
            ""
          )}
        </Modal.Body>
        <Modal.Footer className="border-0" dir={box_head_dir}>
          <Button
            variant="primary"
            onClick={() => {
              createWarehouse(
                slug,
                lang,
                token,
                newSupplierName,
                handleLoader,
                handleSuppliers,
                setShow,
                handleNewSupplierNameErr
              );
            }}
          >
            {_("panel.save")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Loader active={loading} />
      <div
        className="tables-container d-flex flex-column px-2"
        style={{ position: "relative", flexGrow: 3 }}
      >
        <div
          className={`header d-flex ${
            lang === "en" ? "flex-row" : "flex-row"
          } gap-3 align-items-center justify-content-between`}
        >
          <h3 className="fs-1" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.suppliers")}
          </h3>
        </div>
        <div className="footer d-flex flex-column flex-grow-1">
          {suppliers ? (
            <SuppliersTableRow
              payments_list={suppliers}
              handleLoader={handleLoader}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
const label_input = (label, newWarehouseName, handleNewWarehouseName) => {
  return (
    <div className="mb-3">
      <label htmlFor="exampleInputEmail1" className="form-label">
        {label}
      </label>
      <input
        type="text"
        className="form-control py-2 egp"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        value={newWarehouseName}
        onInput={(e) => handleNewWarehouseName(e.target.value)}
      />
    </div>
  );
};
export default Suppliers;
